(function () {
  var ARROW =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeButton(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cc-nav cc-nav--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = ARROW;
    return b;
  }

  function init(scroller) {
    // Jo käsitelty?
    if (scroller.parentNode.classList.contains('cc-carousel')) return;

    var wrap = document.createElement('div');
    wrap.className = 'cc-carousel';
    scroller.parentNode.insertBefore(wrap, scroller);
    wrap.appendChild(scroller);

    var prev = makeButton('prev', 'Edellinen');
    var next = makeButton('next', 'Seuraava');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      return Math.max(scroller.clientWidth * 0.8, 200);
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var x = scroller.scrollLeft;
      wrap.classList.toggle('cc-at-start', x <= 1);
      wrap.classList.toggle('cc-at-end', x >= max - 1);
      wrap.classList.toggle('cc-no-scroll', max <= 1);
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 500); // kuvat ehtivät latautua
  }

  var queued = false;
  function scan() {
    queued = false;
    var list = document.querySelectorAll(
      '.complementary-products .complementary-products--inner'
    );
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  // Complementary-tuotteet ladataan AJAXilla → odota niiden ilmestymistä
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();